'use client';

import { createContext, useContext } from 'react';

type StickySearchContextValue = {
  mobileExpanded: boolean;
  setMobileExpanded: (expanded: boolean) => void;
};

export const StickySearchContext = createContext<StickySearchContextValue | null>(
  null
);

export const useStickySearchContext = () => useContext(StickySearchContext);
